import Vue from 'vue'
import Router from 'vue-router'
import UnauthenticatedTemplate from '@/templates/Unauthenticated'

import AutoLoginPage from '@/pages/unauthenticated/AutoLogin'
import LoginPage from '@/pages/unauthenticated/Login'
import ForgotPage from '@/pages/unauthenticated/Forgot'
import SignUpPage from '@/pages/unauthenticated/SignUp'
import TermsAccept from '@/pages/unauthenticated/TermsAccept'

import DashboardPage from '@/pages/authenticated/Dashboard'
// import LogoutPage from '@/pages/authenticated/Logout'
// import HealthTipsPage from '@/pages/authenticated/HealthTips'
import ChatPage from '@/pages/authenticated/Chat'
// import InboxPage from '@/pages/authenticated/Inbox'
// import ProfilePage from '@/pages/authenticated/Profile'
// import MedicalInfoPage from '@/pages/authenticated/MedicalInfo'
// import EmergencyPage from '@/pages/authenticated/Emergency'
// import EmergencyMapPage from '@/pages/authenticated/EmergencyMap'
// import Frame from '@/pages/Frame'
// import Share from '@/pages/Share'

const LogoutPage = () => import('@/pages/authenticated/Logout')
const HealthTipsPage = () => import('@/pages/authenticated/HealthTips')
// const ChatPage   = () => import('@/pages/authenticated/Chat')
const InboxPage = () => import('@/pages/authenticated/Inbox')
const ProfilePage = () => import('@/pages/authenticated/Profile')
const MedicalInfoPage = () => import('@/pages/authenticated/MedicalInfo')
const EmergencyPage = () => import('@/pages/authenticated/Emergency')
const EmergencyMapPage = () => import('@/pages/authenticated/EmergencyMap')
const SymptomCheckerPage = () => import('@/pages/authenticated/SymptomChecker')
const Frame = () => import('@/pages/Frame')
const Share = () => import('@/pages/Share')
const LegalChiefTermsPage = () => import( '@/pages/authenticated/legalchief/Terms')
const DrDoctorTermsPage = () => import( '@/pages/authenticated/drdoctor/Terms')
const Medi4UTermsPage = () => import( '@/pages/authenticated/medi4u/Terms')
const FreeLegalTermsPage = () => import( '@/pages/authenticated/freelegal/Terms')
const FreeDoctorTermsPage = () => import( '@/pages/authenticated/freedoctor/Terms')
const CoronaVirusPage = () => import( '@/pages/authenticated/Corona')
const CoronaVirusCountriesPage = () => import( '@/pages/authenticated/CoronaCountries')

var termsPage = null;
switch (BUILD_VARIANT) {
  case 'legalchief':
    termsPage = LegalChiefTermsPage;
    break;
  case 'drdoctor':
    termsPage = DrDoctorTermsPage;
    break;
  case 'medi4u':
    termsPage = Medi4UTermsPage;
    break;
  case 'freelegal':
    termsPage = FreeLegalTermsPage;
    break;
  case 'freedoctor':
    termsPage = FreeDoctorTermsPage;
    break;
}

import DocumentsPage from '@/pages/authenticated/Documents'

Vue.use(Router)

window.EventBus = new Vue();

var router = new Router({
  routes: [
    {
      path: "/",
      component: UnauthenticatedTemplate,
      children: [
        {
          path: "/",
          name: 'unauthenticated.login',
          component: LoginPage
        },
        {
          path: "/login/auto",
          name: 'unauthenticated.autologin',
          component: AutoLoginPage
        },
        {
          path: "/forgot",
          name: 'unauthenticated.forgot',
          component: ForgotPage
        },
        {
          path: "/signup",
          name: 'unauthenticated.signup',
          component: SignUpPage
        }
      ]
    },
    {
      path: "/frame",
      name: 'frame',
      component: Frame,
      requireAuth: false
    },
    {
      path: "/dashboard",
      name: 'authenticated.dashboard',
      component: DashboardPage,
      requireAuth: true
    },
    {
      path: "/emergency",
      name: 'authenticated.emergency',
      component: EmergencyPage,
      requireAuth: true
    },
    {
      path: "/symptom",
      name: 'authenticated.symptom',
      component: SymptomCheckerPage,
      requireAuth: true
    },
    {
      path: "/tips",
      name: 'authenticated.healthtips',
      component: HealthTipsPage,
      requireAuth: true
    },
    {
      path: "/corona",
      name: 'authenticated.coronavirus',
      component: CoronaVirusPage,
      requireAuth: true
    },
    {
      path: "/corona/countries",
      name: 'authenticated.coronavirus.countries',
      component: CoronaVirusCountriesPage,
      requireAuth: true
    },
    {
      path: "/chat/:chatId?",
      name: 'authenticated.chat',
      component: ChatPage,
      requireAuth: true
    },
    {
      path: "/inbox",
      name: 'authenticated.inbox',
      component: InboxPage,
      requireAuth: true
    },
    {
      path: "/medical",
      name: 'authenticated.medical',
      component: MedicalInfoPage,
      requireAuth: true
    },
    {
      path: "/profile",
      name: 'authenticated.profile',
      component: ProfilePage,
      requireAuth: true
    },
    {
      path: "/logout",
      name: 'unauthenticated.logout',
      component: LogoutPage,
      requireAuth: true
    },
    {
      path: "/terms",
      name: 'authenticated.terms',
      component: termsPage,
      requireAuth: true
    },
    {
      path: "/documents",
      name: 'authenticated.documents',
      component: DocumentsPage,
      requireAuth: true
    },
    {
      path: "/acceptTerms",
      name: 'unauthenticated.terms',
      component: TermsAccept,
      requireAuth: true
    },
    {
      path: "/emergency/:type",
      name: 'authenticated.emergencymap',
      component: EmergencyMapPage,
      requireAuth: true
    },
    {
      path: "/ext/frame/:url",
      name: 'ext.frame',
      component: Frame,
      requireAuth: false
    },
    {
      path: "/ext/share",
      name: 'ext.share',
      component: Share,
      requireAuth: false
    },
  ]
})

function checkAuth(to, from, next) {
  if (store === null) {
    next({name: 'unauthenticated.login'});
  } else {
    next();
  }
}

export default router;
